import React, { useMemo, useState, useEffect } from "react";

const DAYS = [
  { label: "Sun", value: 0 },
  { label: "Mon", value: 1 },
  { label: "Tue", value: 2 },
  { label: "Wed", value: 3 },
  { label: "Thu", value: 4 },
  { label: "Fri", value: 5 },
  { label: "Sat", value: 6 },
];

export default function WeeklyOffPicker({ value = [], onSave, saving }) {
  const initial = useMemo(() => new Set(value), [value]);
  const [set, setSet] = useState(initial);

  // keep state in sync when parent updates value
  useEffect(() => {
    setSet(new Set(value));
  }, [value]);

  const toggle = (v) => {
    setSet((prev) => {
      const next = new Set(prev);
      next.has(v) ? next.delete(v) : next.add(v);
      return next;
    });
  };

  const selected = [...set].sort((a, b) => a - b);

  return (
    <div className="rounded-2xl border border-gray-200 bg-white p-4 dark:border-white/10 dark:bg-navy-800">
      {/* Header */}
      <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
        <div>
          <div className="text-sm font-semibold text-gray-800 dark:text-white">
            Weekly Off Days
          </div>
          <div className="mt-1 text-xs text-gray-500 dark:text-white/70">
            Admin can choose which weekdays are weekly off (not fixed Sat/Sun).
          </div>
        </div>

        <button
          disabled={saving}
          onClick={() => onSave(selected)}
          className="rounded-lg bg-gradient-to-r from-[#ef145d] to-[#e3955e] px-4 py-2 text-sm text-white transition hover:opacity-95 disabled:cursor-not-allowed disabled:opacity-60"
        >
          {saving ? "Saving..." : "Save"}
        </button>
      </div>

      {/* Day Buttons */}
      <div className="mt-4 flex flex-wrap gap-2">
        {DAYS.map((d) => {
          const active = set.has(d.value);
          return (
            <button
              key={d.value}
              type="button"
              onClick={() => toggle(d.value)}
              className={[
                "min-w-[56px] rounded-lg border px-3 py-2 text-xs font-medium transition",
                active
                  ? "border-brand-500 bg-brand-500/10 text-brand-600 dark:text-brand-400"
                  : "border-gray-200 text-gray-700 hover:bg-gray-50 dark:border-white/10 dark:text-white/80 dark:hover:bg-white/5",
              ].join(" ")}
            >
              {d.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
